import React,{Component} from 'react'
import {Row,Col,Form,Input,Button,Checkbox,Icon,message} from 'antd'
import {reqLogin} from '../../api'
import './login.less'
import userUtils from '../../utills/userUtils'
import {getPackageCodes} from '../../utills/constants'
const Item = Form.Item;
class Login extends Component {
    handleSubmit = (event) => {
        // 阻止事件的默认行为
        event.preventDefault()

        // 对所有表单字段进行检验
        this.props.form.validateFields(async (err, values) => {
            // 检验成功
            if (!err) {
                // console.log('提交登录的ajax请求', values)
                // 请求登录
                const {username, password} = values
                const result = await reqLogin(username, password)
                if (result.code===200) { // 登录成功
                    // 提示登录成功
                    message.success('登录成功')
                    // 跳转到管理界面 (不需要再回退回到登录)
                    userUtils.doLogin(result.data)
                    //清除缓存或退出登录后，无登录信息，无法拿到包装信息，如果没有时，登录时重新获取一下
                    getPackageCodes();
                } else { // 登录失败
                    // 提示错误信息
                    message.error(result.message)
                }

            } else {
                console.log('检验失败!')
            }
        });
    }
    componentDidMount() {
        userUtils.checkLogin()
    }
    render () {
        const { getFieldDecorator} = this.props.form;
        return (
            <div className='login'>
                <div className='login-info-box'>
                    <div className="login-logo"></div>
                    <div className='login-content'>
                        <h2>公铁联运运营管理系统</h2>
                        <Form onSubmit={this.handleSubmit} className="login-form">
                            <Item>
                                {getFieldDecorator('username', {
                                    rules: [{ required: true, message: '请输入用户名' }]
                                })(
                                    <Input
                                        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        placeholder="请输入用户名"
                                    />
                                )}
                            </Item>
                            <Form.Item>
                                {getFieldDecorator('password', {
                                    rules: [{ required: true, message: '请输入密码' }]
                                })(
                                    <Input
                                        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                        type="password"
                                        placeholder="请输入密码"
                                    />
                                )
                                }
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="login-form-button">
                                    登录
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
                <div className='login-bank'>
                    <p>浙ICP备16022887号-2</p>
                </div>
            </div>
        )
    }
}
const WrapLogin = Form.create()(Login)
export default WrapLogin